import React from "react";
import { Card, CardBody, CardSubtitle, CardTitle, Row, Col } from "reactstrap";
import ReactApexChart from "react-apexcharts";

const DoughnutChart = (props) => {
  const incomeData = props.incomeData;
  const options = {
    chart: {
      type: "donut",
    },
    labels: [
      "Performance Training",
      "Treatment Sessions",
      "Functional Group",
      "Strength and Conditioning",
      "Rehab",
    ],
    tooltip: {
      enabled: true,
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return `<div>
        <span>Rs. ${series[seriesIndex]}</span>
      </div>`;
      },
    },
    legend: {
      position: "bottom",
      offsetY: 5,
    },
  };

  const series = [
    incomeData.performance_Training,
    incomeData.treatment_Sessions,
    incomeData.functional_Group,
    incomeData.strength_and_Conditioning,
    incomeData.rehab,
  ];

  return (
    <Card>
      <CardBody style={{ height: "484.19px" }}>
        <CardTitle tag="h5">Session Distribution</CardTitle>
        <CardSubtitle className="text-muted" tag="h6">
          Session Report
        </CardSubtitle>
        <div style={{ marginTop: "70px", marginBottom: "10px" }}>
          <ReactApexChart
            options={options}
            series={series}
            type="donut"
            height={350}
          />
        </div>
      </CardBody>
    </Card>
  );
};

export default DoughnutChart;
